function alertParameterTerminationReasonController(alertsFrameworkService, terminationReasonService) {
    const $ctrl = this;

    $ctrl.areTerminationReasonsLoading = false;

    $ctrl.$onInit = function () {
        loadTerminationReasons();

        $ctrl.SourceTerminationReasonKeys = alertsFrameworkService.getKeyArrayFromCsv($ctrl.model);
    };

    /* Handle Model Changes on the Parent */
    $ctrl.$onChanges = function(changes) {
        if (changes.model){
            const newKeys = alertsFrameworkService.getKeyArrayFromCsv(changes.model.currentValue);
            const arraysEqual =
                newKeys.length === $ctrl.SourceTerminationReasonKeys.length
                && newKeys.every((value, index) => value === $ctrl.SourceTerminationReasonKeys[index]);

            if (!arraysEqual)
            {
                $ctrl.SourceTerminationReasonKeys = newKeys;
            }
        }
    }


    $ctrl.TerminationReasonsChanged = (item, model) => {
        const csvValue = alertsFrameworkService.getCsvFromKeyArray($ctrl.SourceTerminationReasonKeys);

        $ctrl.onUpdate({csvValue: csvValue});
    };


    function loadTerminationReasons() {
        $ctrl.areTerminationReasonsLoading = true;

        return terminationReasonService
            .getTerminationReasonV2($ctrl.subscriberKey)
            .then((terminationReasons) => {

                $ctrl.terminationReasons = terminationReasons.toSorted((a, b) => {
                    const nameA = a.sourceTerminationReasonName.toUpperCase();
                    const nameB = b.sourceTerminationReasonName.toUpperCase();

                    if (nameA < nameB) {
                        return -1;
                    }

                    if (nameA > nameB) {
                        return 1;
                    }

                    return 0;
                });

                $ctrl.areTerminationReasonsLoading = false;
            });
    }
}

angular
    .module("angus.components")
    .component("alertTerminationReason", {
        controller: alertParameterTerminationReasonController,
        bindings: {
            subscriberKey: "<",
            label: "<",
            model: "<",
            isReadOnly: "<",
            onUpdate: "&"
        },
        template: `
<label class="control-label" for="terminationReasons">{{$ctrl.label || 'Reason'}}
    <i class="fa fa-spinner fa-spin" data-fade-toggle="areTerminationReasonsLoading"></i></label>

<ui-select
    class="alert-select" 
	multiple 
	ng-model="$ctrl.SourceTerminationReasonKeys" 
	ng-disabled="!$ctrl.terminationReasons.length || $ctrl.isReadOnly" 
	on-select="$ctrl.TerminationReasonsChanged($item, $model)" 
	on-remove="$ctrl.TerminationReasonsChanged($item, $model)"
>
    <ui-select-match placeholder="Select termination reasons...">{{$item.sourceTerminationReasonName}}</ui-select-match>
    <ui-select-choices repeat="terminationReason.sourceTerminationReasonKey as terminationReason in $ctrl.terminationReasons | filter: {sourceTerminationReasonName: $select.search}">
        {{terminationReason.sourceTerminationReasonName || '\u00A0'}}</ui-select-choices>
</ui-select>
		`
    });
